import loadable from '@loadable/component'

export default [
  {
    path: '/DualCompetition',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DualCompetition" */ '~/pages/ToyBricks/CustomComponents/DualCompetition/index'
        )
    ),
  },
  {
    path: '/DualCompetition/Rewards',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DualCompetition-Rewards" */ '~/pages/ToyBricks/CustomComponents/DualCompetition/pages/Rewards/index'
        )
    ),
  },
  {
    path: '/DualCompetition/Rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DualCompetition-Rules" */ '~/pages/ToyBricks/CustomComponents/DualCompetition/pages/Rules/index'
        )
    ),
  },
  {
    path: '/DualCompetitionGiftBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DualCompetition-GiftBanner" */ '~/pages/ToyBricks/CustomComponents/DualCompetition/components/GiftBanner'
        )
    ),
  },
  {
    path: '/DualCompetitionModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DualCompetition-ApngTextModal" */ '~/pages/ToyBricks/CustomComponents/DualCompetition/components/ApngTextModal'
        )
    ),
  },
]
